




























import { Record } from "@/common/api/leaderboard/Record";
import Vue, { VueConstructor } from "vue";

export default (Vue as VueConstructor<Vue>).extend({
  props: {
    users: {
      type: Array as () => Record[],
      default: () => []
    }
  },
  methods: {
    indexFix(index: number): number {
      return index + 1;
    }
  }
  // computed: {
  //   filteredUsers(): Record[] {
  //     return this.users.filter(
  //       (value: Record, userIndex: number, userRecords: Record[]) => {
  //         if (!(value as any).id) return true;
  //         let index = 0;
  //         while (index < userRecords.length) {
  //           const element = userRecords[index];
  //           if (
  //             element.initials === value.initials &&
  //             element.score === value.score &&
  //             !(element as any).id
  //           ) {
  //             return false;
  //           }
  //           index++;
  //         }
  //         return true;
  //       }
  //     );
  //   }
  // }
});
